// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-card {
  max-width: 800px;
  margin: 2rem auto;
}

.about-card-content {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.1),
    0 1px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.about-card-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #8B4513, #D2B48C, #F5DEB3);
  border-radius: 20px 20px 0 0;
}

.about-card-content:hover {
  transform: translateY(-5px);
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.15),
    0 5px 15px rgba(0, 0, 0, 0.1);
}

.about-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.about-emoji {
  font-size: 2rem;
  animation: wave 2s ease-in-out infinite;
}

@keyframes wave {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(20deg); }
  75% { transform: rotate(-10deg); }
}

.about-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  background: linear-gradient(135deg, #8B4513, #D2B48C);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.about-text {
  margin-bottom: 2rem;
}

.about-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #495057;
  margin: 0;
  text-align: justify;
}

.about-details-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #8B4513, #A0522D);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(139, 69, 19, 0.3);
  position: relative;
  overflow: hidden;
}

.about-details-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.about-details-btn:hover::before {
  left: 100%;
}

.about-details-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(139, 69, 19, 0.4);
  background: linear-gradient(135deg, #A0522D, #8B4513);
}

.about-details-btn:active {
  transform: translateY(0);
}

.arrow-icon {
  transition: transform 0.3s ease;
}

.about-details-btn:hover .arrow-icon {
  transform: translateX(3px);
}

/* Dark theme support */
[data-theme="dark"] .about-card-content {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

[data-theme="dark"] .about-title {
  background: linear-gradient(135deg, #D2B48C, #F5DEB3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-theme="dark"] .about-text p {
  color: #ecf0f1;
}

/* Responsive design */
@media (max-width: 768px) {
  .about-card {
    margin: 1rem auto;
    padding: 0 0.5rem;
  }
  
  .about-card-content {
    padding: 1.5rem;
  }
  
  .about-title {
    font-size: 1.5rem;
  }
  
  .about-text p {
    font-size: 1rem;
  }
  
  .about-details-btn {
    padding: 0.8rem 1.5rem;
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutCard/AboutCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf;;iCAE+B;EAC/B,0CAA0C;EAC1C,mCAAmC;EACnC,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B;;iCAE+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,MAAM,wBAAwB,EAAE;EAChC,MAAM,yBAAyB,EAAE;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF","sourcesContent":[".about-card {\n  max-width: 800px;\n  margin: 2rem auto;\n}\n\n.about-card-content {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 20px;\n  padding: 2.5rem;\n  box-shadow: \n    0 10px 30px rgba(0, 0, 0, 0.1),\n    0 1px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.about-card-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #8B4513, #D2B48C, #F5DEB3);\n  border-radius: 20px 20px 0 0;\n}\n\n.about-card-content:hover {\n  transform: translateY(-5px);\n  box-shadow: \n    0 20px 40px rgba(0, 0, 0, 0.15),\n    0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.about-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.about-emoji {\n  font-size: 2rem;\n  animation: wave 2s ease-in-out infinite;\n}\n\n@keyframes wave {\n  0%, 100% { transform: rotate(0deg); }\n  25% { transform: rotate(20deg); }\n  75% { transform: rotate(-10deg); }\n}\n\n.about-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin: 0;\n  background: linear-gradient(135deg, #8B4513, #D2B48C);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.about-text {\n  margin-bottom: 2rem;\n}\n\n.about-text p {\n  font-size: 1.1rem;\n  line-height: 1.8;\n  color: #495057;\n  margin: 0;\n  text-align: justify;\n}\n\n.about-details-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: linear-gradient(135deg, #8B4513, #A0522D);\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 50px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(139, 69, 19, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.about-details-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s ease;\n}\n\n.about-details-btn:hover::before {\n  left: 100%;\n}\n\n.about-details-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(139, 69, 19, 0.4);\n  background: linear-gradient(135deg, #A0522D, #8B4513);\n}\n\n.about-details-btn:active {\n  transform: translateY(0);\n}\n\n.arrow-icon {\n  transition: transform 0.3s ease;\n}\n\n.about-details-btn:hover .arrow-icon {\n  transform: translateX(3px);\n}\n\n/* Dark theme support */\n[data-theme=\"dark\"] .about-card-content {\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n[data-theme=\"dark\"] .about-title {\n  background: linear-gradient(135deg, #D2B48C, #F5DEB3);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n[data-theme=\"dark\"] .about-text p {\n  color: #ecf0f1;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .about-card {\n    margin: 1rem auto;\n    padding: 0 0.5rem;\n  }\n  \n  .about-card-content {\n    padding: 1.5rem;\n  }\n  \n  .about-title {\n    font-size: 1.5rem;\n  }\n  \n  .about-text p {\n    font-size: 1rem;\n  }\n  \n  .about-details-btn {\n    padding: 0.8rem 1.5rem;\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
